import { render, staticRenderFns } from "./sell_report.vue?vue&type=template&id=2324e083"
import script from "./sell_report.vue?vue&type=script&lang=js"
export * from "./sell_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports